import { forwardRef } from 'react';
import {
  type TypographyProps as MuiTypographyProps,
  Typography as MuiTypography,
  Theme,
} from '@mui/material';
import { TitleTypography } from './title-typography';

export interface TypographyProps
  extends Omit<MuiTypographyProps, 'fontWeight' | 'color'> {
  heading?: boolean;
  fontWeight?: 'light' | 'regular' | 'medium' | 'semibold' | 'bold';
  color?:
    | 'inherit'
    | 'initial'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'warning'
    | 'info'
    | 'orange'
    | 'success'
    | 'grayBlue'
    | 'blueLight'
    | 'blue'
    | 'purple'
    | 'indigo'
    | 'rose'
    | string
    | undefined
    | ((theme: Theme) => string | undefined);
}

export const Typography = forwardRef<
  HTMLParagraphElement | HTMLSpanElement,
  TypographyProps
>(({ heading, fontWeight, color, sx, ...rest }, ref) => {
  const weight = fontWeight === 'semibold' ? 600 : fontWeight;
  if (heading)
    return (
      <TitleTypography
        ref={ref}
        fontWeight={weight}
        sx={{
          color: color,
          ...sx,
        }}
        {...rest}
      />
    );
  return (
    <MuiTypography
      ref={ref}
      fontWeight={weight}
      sx={{
        color: color,
        ...sx,
      }}
      {...rest}
    />
  );
});
